import React from 'react'
import {
  Badge
} from 'reactstrap'

const TagBadgeComponent = (props) => {
  const { tag } = props


  return (
    < Badge
      className="badge badge-pill d-flex flex-column align-items-center justify-content-center py-1 mx-2"
      style={{
        backgroundColor: tag.backgroundColor || '#F2F2FE',
        border: 'none',
        outline: 'none',
        boxShadow: 'none',
        maxWidth: '150px',

      }}
    >
      <span
        style={{
          color: tag.textColor || '#696CFF',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {tag.name || 'TAG'}
      </span>
    </Badge >
  )
}




export default TagBadgeComponent
